import React, { useEffect, useState } from "react";

const IntervalControlModal = ({ show, onClose }) => {
  const [targetType, setTargetType] = useState("Single Device");
  const [devices, setDevices] = useState([]);
  const [targetValue, setTargetValue] = useState("");
  const [interval, setInterval] = useState("15");

  useEffect(() => {
    fetch("/api/devices")
      .then((res) => res.json())
      .then((data) => setDevices(data))
      .catch((err) => console.error("Failed to fetch devices", err));
  }, []);

  const getDropdownOptions = () => {
    switch (targetType) {
      case "Single Device":
        return devices.map((d) => d.deviceId);
      case "By Phase Group":
        return [...new Set(devices.map((d) => d.knownPhase || d.phase).filter(Boolean))];
      case "By Transformer Group":
        return [...new Set(devices.map((d) => d.transformerId || d.transformerGroup).filter(Boolean))];
      default:
        return [];
    }
  };

  const handleSend = () => {
    const payload = {
      interval: parseInt(interval),
    };

    if (targetType === "Single Device") {
      payload.controlOption = "device";
      payload.deviceId = targetValue;
    } else if (targetType === "All Devices") {
      payload.controlOption = "all";
    } else if (targetType === "By Phase Group") {
      payload.controlOption = "phase";
      payload.phase = targetValue;
    } else if (targetType === "By Transformer Group") {
      payload.controlOption = "transformer";
      payload.transformer = targetValue;
    } else {
      alert("Invalid target type");
      return;
    }

    fetch("/api/interval-control", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        alert(data.message || "Update sent");
        onClose();
      })
      .catch((err) => {
        console.error("Failed to send interval update", err);
        alert("Failed to send update");
      });
  };

  if (!show) return null;

  return (
    <div style={overlayStyles}>
      <div style={modalStyles}>
        <h2>📡 Device Interval Control</h2>

        <label>Target:</label>
        <select
          value={targetType}
          onChange={(e) => {
            setTargetType(e.target.value);
            setTargetValue("");
          }}
        >
          <option>Single Device</option>
          <option>All Devices</option>
          <option>By Phase Group</option>
          <option>By Transformer Group</option>
        </select>

        {targetType !== "All Devices" && (
          <>
            <label style={{ marginTop: "1rem" }}>
              {targetType === "Single Device"
                ? "Device ID:"
                : targetType === "By Phase Group"
                ? "Phase Group:"
                : "Transformer Group:"}
            </label>
            <select value={targetValue} onChange={(e) => setTargetValue(e.target.value)}>
              <option value="">-- Select --</option>
              {getDropdownOptions().map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </>
        )}

        <label style={{ marginTop: "1rem" }}>New Reporting Interval (minutes):</label>
        <input
          type="number"
          value={interval}
          onChange={(e) => setInterval(e.target.value)}
        />

        <div style={{ marginTop: "1.5rem", display: "flex", justifyContent: "space-between" }}>
          <button onClick={handleSend} style={sendStyle}>Send</button>
          <button onClick={onClose} style={cancelStyle}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

const overlayStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modalStyles = {
  background: "white",
  padding: "2rem",
  borderRadius: "10px",
  width: "400px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
  display: "flex",
  flexDirection: "column",
};

const sendStyle = {
  backgroundColor: "#28a745",
  color: "white",
  padding: "10px 20px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

const cancelStyle = {
  backgroundColor: "#dc3545",
  color: "white",
  padding: "10px 20px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

export default IntervalControlModal;
